import React from "react";

export const Textarea = (props) => {
  const { field, fieldId } = props;
  const { label, placeholder, isRequired, cssClass, id } = field;
  // Gravity Form field ID ~ name.
  const gfName = `input_${id}`;
  return (
    <div
      className={`${cssClass ? ` ${cssClass}` : ""}
        ${isRequired ? " required" : ""}`}
    >
      <label htmlFor={fieldId}>{label}</label>
      <textarea
        name={gfName}
        id={fieldId}
        placeholder={placeholder}
        required={!!isRequired}
        resize="none"
      />
    </div>
  );
};
